const Config = (function () {
    return {
        "REGION": "JP",
        "LANGUAGE": "jp",
        // "client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        // "client_id": "atvn55xkh2pfn1vs5fwqtr1xeb", // v2 线下
        "client_id": "emvg3hk2tqu3q37fcw6cwyl4bi",  // v2 线上
        // "backend_host": "https://y5384v7heb.execute-api.us-east-1.amazonaws.com/prod",
        // "backend_host": "https://account.api.woankeji.cn", // v2 线下
        "backend_host": "https://account.api.switchbot.net",  // v2 线上
        // "backend_host": "https://5oh0cgsl37.execute-api.us-east-1.amazonaws.com/prod",  // v2 灰度线上
        // "backend_host": "https://bana6ys6sk.execute-api.us-east-1.amazonaws.com/prod",
        // "mobile_management_backend_host": "https://core.us.api.woankeji.cn", // v2 线下
        "mobile_management_backend_host": "https://wonderlabs.us.api.switchbot.net/homepage", // v2 线上
        "wonder_backend_host": "https://wonderlabs.us.api.switchbot.net/wonder",
        "message_backend_host": "https://wonderlabs.us.api.switchbot.net/message",
        "lottery_host": "https://gd06rick00.execute-api.us-east-1.amazonaws.com/prod",
        "third_part_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "amazon_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "google_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "apple_client_id": "r42t84lzaq2nqvy06ncrqzwhn0",
        "error_code": {
            // 2024年5月20日16:06:39 新增 错误码
            2012: "このアカウントは既に使用されています。直接にログインしてください。", // 这个有专门的接口，不做处理 账号已存在
            2024: "密码错误次数过多（5 次）", // 这个有专门的接口返回后人机验证 密码错误次数过多（5 次）
            2030: "コードの送信失敗しました。もう一度試してください。",
            2033: "コードの送信失敗しました。もう一度試してください。", // 验证码连续 3 次输入错误，
            2035: "SMSに送らせる認証コードの送信回数は上限に達しました", // 验证码下发已达上限
            2036: "用户从流程第一步重新开始",
            2007: "MFA にエラーがあります",
            2034: "人間とマシンの検証に失敗しました",
            2050: "リクエスト回数が多すぎます。しばらくしてからもう一度お試しください。",
            2402: "サードパーティのアカウントを自分で繰り返しバインドする",
            2403: "現在の 3 者は他のスイッチボットによって束縛されています",
            2042: "アカウントは Shopify にバインドされています",
            2404: "外部アカウントの情報を読み込めません。",
            2040: "この Shopify アカウントが見つかりません",
            // -------end 新增 错误码
            2020: "ユーザー名またはパスワードが間違っています", // 用户名或密码错误
            2010: "アカウントが存在しません", // 账户不存在
            2011: "メールアドレスが認証していません", // 电子邮件地址未验证
            2013: "このメールアドレスはあなたのGoogleアカウントに関連付けられています。Googleアカウントにログインしてください。", // 该电子邮件地址与您的 Google 帐户关联。请登录您的 Google 帐户。
            2014: "このメールアドレスはあなたのAmazonアカウントに関連付けられています。Amazonアカウントにログインしてください。", // 与您的 Amazon 帐户关联
            2015: "このメールアドレスはあなたのApple IDに関連付けられています。Apple IDにログインしてください。", // 与您的 Apple 帐户关联
            2031: "認証コードが間違っています", // 验证码不正确
        }
    }
})()